export default "__VITE_ASSET__ZQ$3dx4r__"